module.exports = __webpack_public_path__ + "static/media/meteor.a4335fec.svg";